(function () {
  'use strict';

  // Detect device type
  function getDeviceType() {
    const width = window.innerWidth || document.documentElement.clientWidth;
    const ua = navigator.userAgent.toLowerCase();

    // Check for mobile/tablet via user agent
    const isMobileUA = /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(ua);

    // Check for mobile via screen width (< 768px)
    const isMobileWidth = width < 768;

    // Device is mobile if either UA or width indicates mobile
    if (isMobileUA || isMobileWidth) {
      return 'mobile';
    }

    return 'desktop';
  }

  // Detect if visitor is a bot
  function isBot() {
    const ua = navigator.userAgent.toLowerCase();

    // Common bot patterns
    const botPatterns = [
      'bot',
      'crawl',
      'spider',
      'slurp',
      'bingpreview',
      'facebookexternalhit',
      'whatsapp',
      'twitter',
      'pinterest',
      'linkedin',
      'google',
      'baidu',
      'headlesschrome',
      'phantomjs',
      'selenium',
      'curl',
      'wget',
      'python',
      'java',
      'ruby',
    ];

    // Check if user agent matches any bot pattern
    for (const pattern of botPatterns) {
      if (ua.includes(pattern)) {
        return true;
      }
    }

    // Additional checks for headless browsers
    if (navigator.webdriver) {
      return true;
    }

    // Check for missing common browser features
    if (!navigator.languages || navigator.languages.length === 0) {
      return true;
    }

    return false;
  }

  // Get browser width for analytics
  function getBrowserWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  // Build the device/bot payload for the current viewport
  function deviceAttributes() {
    return {
      _device_type: getDeviceType(),
      _browser_width: getBrowserWidth().toString(),
      _is_bot: isBot().toString(),
      _user_agent: navigator.userAgent.substring(0, 255), // Shopify limit is 255 chars
    };
  }

  // The shared writer (snippets/cart-attribute-sync.liquid) serializes cart writes and posts only changed keys
  function updateCartAttributes() {
    window.CoraCartAttributes.write(deviceAttributes()).catch((error) => {
      console.warn('Device/bot tracking update failed:', error);
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartAttributes);
  } else {
    updateCartAttributes();
  }

  // Also update on window resize (device orientation change)
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // Only update if device type or width changed significantly
      window.CoraCartAttributes.update((cart) => {
        // An unreadable cart gives nothing to compare against, so a resize posts nothing rather than its full payload.
        if (!cart) return null;
        const attributes = deviceAttributes();
        const current = cart.attributes || {};
        const currentWidth = parseInt(current._browser_width || '0');
        const widthMoved = Math.abs(currentWidth - Number(attributes._browser_width)) > 50;
        return current._device_type !== attributes._device_type || widthMoved
          ? { attributes: attributes }
          : null;
      }).catch((error) => console.warn('Cart check failed:', error));
    }, 500);
  });
})();
